const FormError = ({ errors }) => (
  <div className="error-notification-box alert alert-danger">
    <a className="close" data-dismiss="alert" href="#">&times;</a>
    { errors.map((err, i) => <p key={ i }>&bull; { err }</p>) }
  </div>
)

FormError.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default FormError



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/shared/components/FormError.js